module.exports = __webpack_public_path__ + "static/media/logo.25eb1332.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.svg
// module id = 139
// module chunks = 0